import * as React from "react";

const SvgPlaySolid = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M10.47 34c-.235 0-.47-.057-.686-.172A1.404 1.404 0 019 32.564V6.434c0-.535.294-1.014.784-1.263a1.476 1.476 0 011.51.077l20.059 13.055c.412.268.647.708.647 1.187 0 .479-.235.938-.647 1.206l-10.03 6.537-10.029 6.537c-.255.153-.53.23-.823.23z"
			fill="currentColor"
		/>
	</svg>
);

export default SvgPlaySolid;
